import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUserInfo } from 'redux/userInfo/userInfoSlice';
import { ROUTE_DENIED } from 'constants/routerPath';

const adminRoles = ['file_bucket_manager_admin'];

export function useFileBucketAccess() {
  const { userInfo } = useSelector(selectUserInfo);
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (!userInfo.contactId) return;

    const hasAdminRole = userInfo.roles.some((role: any) =>
      adminRoles.includes(role),
    );

    // Also allow users in the 'Admins' role group as a fallback
    const hasAdminsGroup = userInfo.userRoleGroups?.some((group: any) =>
      group.name === 'Admins',
    );

    const isAllowed = hasAdminRole || hasAdminsGroup;

    if (!isAllowed) {
      navigate(ROUTE_DENIED);
    }

    setIsAdmin(isAllowed);
  }, [navigate, userInfo]);

  return { isAdmin, customerId: userInfo.customerId };
}
